import React from 'react';
import { Modal } from 'components/Modal';
import { DealerListViewContainer } from 'pages/Shared/Dealer/DealerListView/DealersListViewContainer';
import { IDealerItem } from 'pages/Shared/Dealer/Models/dealers';
import { Button, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface IDealerDetailModel {
  show: boolean;
  title: string;
  setSelectedDealer: (dealer: IDealerItem | undefined) => void;
  onClose: () => void;
  dealerData: IDealerItem[];
  setErrorString: (error: string) => void;
  assignedDealerId: string;
}

export const DealerDetailModelComponent = ({
  show,
  title,
  setSelectedDealer,
  dealerData,
  onClose,
  setErrorString,
  assignedDealerId,
}: IDealerDetailModel) => {
  const { t } = useTranslation();
  const [localDealerState, setLocalDealerState] = React.useState<
    IDealerItem | undefined
  >(undefined);

  React.useEffect(() => {
    if (assignedDealerId && dealerData.length) {
      const matchedDealer = dealerData.find(
        (dealer) => dealer.dealerId === assignedDealerId
      );
      if (matchedDealer) {
        setLocalDealerState(matchedDealer);
      } else {
        setLocalDealerState(undefined);
      }
    }
  }, [assignedDealerId, dealerData]);

  return (
    <Modal
      title={title}
      show={show}
      onClose={onClose}
      closeOnOutSideClick={false}
      size="xl"
      className="customer-detail-modal"
      footer={
        <>
          <Row className="w-100 justify-content-end align-items-center">
            <Col xs="auto" className="d-flex align-items-center mt-10 mb-10">
              <Button
                className="customer-mode-footer-btn mr-2"
                variant="primary"
                disabled={!dealerData.length || !localDealerState}
                size="sm"
                onClick={() => {
                  if (localDealerState) {
                    setSelectedDealer(localDealerState);
                  } else {
                    setErrorString(t('customerManagement.modal.errorDealer'));
                  }
                }}
              >
                {t('customerManagement.modal.selectDealer')}
              </Button>
            </Col>
          </Row>
        </>
      }
    >
      <DealerListViewContainer
        setSelectedDealer={setLocalDealerState}
        selectedDealer={localDealerState}
        dealerData={dealerData}
      />
    </Modal>
  );
};

DealerDetailModelComponent.defaultProps = {};
